<section class="w-full h-250">
    <div class="flex flex-col items-center justify-center">
        <div class="w-[100%] pt-4">
            <div class="bg-primary-500">
                <div class="mx-auto max-w-7xl px-4 py-12 sm:px-6 lg:py-16 lg:px-8">
                    <div class="px-6 py-6 md:px-12 lg:flex lg:items-center lg:px-16">
                        <div class="lg:flex-1 xl:w-0">
                            <h2 class="text-2xl font-extrabold tracking-wider text-white sm:text-3xl">Email Newsletter
                            </h2>
                            <p class="mt-3 max-w-3xl text-lg leading-6 text-white">Sign up for our email newsletter to stay up to date.</p>
                        </div>
                        <div class="mt-8 sm:w-full sm:max-w-md xl:mt-0 xl:ml-8">
                            <form class="sm:flex" id="revue-form" target="_blank">
                                <input type="email" autocomplete="email" required=""
                                    class="w-full rounded-md bg-white px-5 py-3 placeholder-gray-500 focus:outline-none focus:ring-0"
                                    placeholder="Enter your email"><button type="submit"
                                    class="w-full rounded-lg uppercase font-semibold p-3 border-accent-500 bg-accent-500 text-primary-100 tracking-wide cursor-pointer sm:mt-0 sm:ml-3 sm:w-auto sm:flex-shrink-0 hover:text-primary-500 hover:bg-primary-100 transition ease-out duration-500">Subscribe</button>
                            </form>
                            <p class="mt-3 text-sm text-white">We will never send any spam emails. Promise.</p>
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
</section>